module.exports = __webpack_public_path__ + "static/media/payment-history-empty.062c4732.svg";